import { render } from "./EnvioDocumentos.vue?vue&type=template&id=510f41c6&scoped=true"
import script from "./EnvioDocumentos.vue?vue&type=script&lang=js"
export * from "./EnvioDocumentos.vue?vue&type=script&lang=js"

import "./EnvioDocumentos.vue?vue&type=style&index=0&id=510f41c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510f41c6"]])

export default __exports__